import React from 'react';
import { CollapsibleList } from './CollapsibleList';
import setCorrectLinks from './setCorrectLinks';
import { isEmptyArray } from '../../utils/ArrayUtils';
export var NeighbourRegions = function NeighbourRegions(_ref) {
  var regions = _ref.regions,
    regionType = _ref.regionType,
    domain = _ref.domain;
  if (isEmptyArray(regions)) {
    return null;
  }
  var regionsWithLink = setCorrectLinks(regions, domain);
  return /*#__PURE__*/React.createElement("div", {
    className: "grid-item desk-one-third lap-one-half palm-one-whole padding-bottom-xl"
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-body-medium-bold margin-bottom-xs",
    "data-testid": "neighbour-regions"
  }, regionType), /*#__PURE__*/React.createElement(CollapsibleList, {
    items: regionsWithLink
  }));
};